import { DocItem } from '@epam/uui-docs';

export const CreateThemeDocItem: DocItem = {
    id: 'createTheme',
    name: 'Create custom theme',
    parentId: 'themes',
    examples: [
        { descriptionPath: 'create-theme' },
    ],
};
